import { AccountDetailsParameters } from './AccountDetailsParameters';
import { User } from './User';

export class GetCommand
{
  Command: string;
  ProviderId: string;
  BankId: number;
  UserName: string;
}